import React, { useEffect } from 'react';
import { Message } from '../types';
import styles from './MessageDisplay.module.css';

interface MessageDisplayProps {
  message: Message | null;
  onDismiss: () => void;
}

export default function MessageDisplay({
  message,
  onDismiss,
}: MessageDisplayProps) {
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(onDismiss, 5000);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  if (!message) return null;

  return (
    <div
      className={`${styles.message} ${styles[message.type]}`}
      role="alert"
    >
      <span>{message.text}</span>
      <button
        onClick={onDismiss}
        className={styles.closeButton}
        aria-label="Dismiss message"
      >
        ×
      </button>
    </div>
  );
}
